import { render } from "./CoursewareMedia.vue?vue&type=template&id=b6f0be9e&scoped=true"
import script from "./CoursewareMedia.vue?vue&type=script&lang=js"
export * from "./CoursewareMedia.vue?vue&type=script&lang=js"

import "./CoursewareMedia.vue?vue&type=style&index=0&id=b6f0be9e&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6f0be9e"]])

export default __exports__